import { useMemo } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { useGetLabelEntitiesQuery } from 'features/metadata/metadata';
import { useActiveOrganisation } from 'hooks/useActiveOrganisation';
import { entityTypes } from 'pages/translation/config/Constants';

const emptyArray = [];

export function useGetBlockLabelEntities(documentId, blockId) {
    const organisationId = useActiveOrganisation();

    const filterSection = useMemo(() => {
        // Return a unique selector instance for this page so that
        // the filtered results are correctly memoized
        return createSelector(
            (res) => res.data,
            (_res, blockId) => blockId,
            (data, blockId) => {
                if (data) {
                    return data.filter((labelEntity) => parseInt(labelEntity.entityId) === blockId);
                }

                return emptyArray;
            },
        );
    }, []);

    const { entityLabelEntities } = useGetLabelEntitiesQuery(
        {
            entityType: entityTypes.BLOCK,
            organisationId,
            documentId,
        },
        {
            selectFromResult: (result) => ({
                entityLabelEntities: filterSection(result, blockId),
            }),
        },
    );

    return entityLabelEntities;
}
